export default __webpack_public_path__ + "static/media/doubts-img.6b296780.png";